{
  "clinicalNotes": "Catatan Klinis",
  "noteType": "Jenis Catatan",
  "author": "Penulis",
  "dateTime": "Tanggal/Waktu",
  "content": "Isi",
  "addNote": "Tambah Catatan",
  "editNote": "Ubah Catatan",
  "signNote": "Tanda Tangani Catatan",
  "signed": "Sudah Ditandatangani",
  "unsigned": "Belum Ditandatangani",
  "types": {
    "progressNote": "Catatan Perkembangan",
    "admissionNote": "Catatan Rawat Inap",
    "dischargeNote": "Catatan Pulang",
    "consultNote": "Catatan Konsultasi",
    "procedureNote": "Catatan Prosedur"
  },
  "editor": {
    "newNote": "Catatan Baru",
    "titlePlaceholder": "Judul catatan…",
    "create": "Buat",
    "cancel": "Batal",
    "cosignFilterLabel": "Tampilkan Hanya Catatan yang Perlu Ditandatangani Bersama",
    "emptyNoCosign": "Tidak ada catatan yang perlu ditandatangani bersama",
    "emptyNoNotes": "Belum ada catatan",
    "emptySelection": "Pilih catatan atau buat yang baru",
    "emptySelectionHint": "Pilih dari daftar di kiri atau klik \"+ Catatan Baru\" untuk memulai.",
    "unknownAuthor": "Tidak diketahui",
    "needsCosignBadge": "Perlu Tanda Tangan Bersama",
    "amendmentBanner": "Amandemen catatan #{{parentId}} — Alasan: {{reason}}",
    "signedBanner": "Ditandatangani oleh {{name}} pada {{when}} — Catatan ini hanya-baca.",
    "signedByFallback": "dokter",
    "saving": "Menyimpan…",
    "autoSaved": "Tersimpan otomatis",
    "actions": {
      "saveDraft": "Simpan Draf",
      "signNote": "Tanda Tangani Catatan",
      "amend": "Amandemen",
      "cosign": "Tanda Tangan Bersama",
      "printLabel": "Cetak Catatan"
    },
    "copyForward": "Salin catatan terakhir",
    "copyForwardHint": "Menyalin catatan bertanda tangan dari {{date}} — tinjau dan perbarui setiap baris",
    "copiedForwardBadge": "Disalin"
  },
  "dialog": {
    "sign": {
      "title": "Tanda Tangani Catatan",
      "body": "Yakin ingin menandatangani catatan ini? Tindakan ini tidak dapat dibatalkan. Catatan akan menjadi hanya-baca setelah ditandatangani.",
      "cancel": "Batal",
      "confirm": "Konfirmasi Tanda Tangan"
    },
    "amend": {
      "title": "Amandemen Catatan",
      "body": "Mohon berikan alasan amandemen ini. Catatan akan diperbarui dan ditandai sebagai diamandemen.",
      "reasonPlaceholder": "Alasan amandemen…",
      "cancel": "Batal",
      "confirm": "Konfirmasi Amandemen"
    },
    "cosign": {
      "title": "Tanda Tangan Bersama Catatan",
      "body": "Yakin ingin menandatangani catatan ini bersama? Ini menyatakan bahwa Anda telah meninjau dan menyetujui isi catatan.",
      "cancel": "Batal",
      "confirm": "Konfirmasi Tanda Tangan Bersama"
    }
  },
  "toast": {
    "created": "Catatan dibuat",
    "createFailed": "Gagal membuat catatan",
    "titleRequired": "Mohon masukkan judul catatan",
    "draftSaved": "Draf tersimpan",
    "signed": "Catatan berhasil ditandatangani",
    "signFailed": "Gagal menandatangani catatan",
    "amended": "Catatan berhasil diamandemen",
    "amendFailed": "Gagal mengamandemen catatan",
    "amendReasonRequired": "Mohon berikan alasan amandemen",
    "cosigned": "Catatan berhasil ditandatangani bersama",
    "cosignFailed": "Gagal menandatangani catatan bersama"
  },
  "status": {
    "draft": "Draf",
    "unsigned": "Belum Ditandatangani",
    "signed": "Ditandatangani",
    "amended": "Diamandemen",
    "cosigned": "Ditandatangani Bersama",
    "cosignNeeded": "Perlu Tanda Tangan Bersama",
    "pendingSignature": "Menunggu Tanda Tangan",
    "addendum": "Tambahan",
    "cosignPending": "Menunggu Tanda Tangan Bersama"
  },
  "worklist": {
    "title": "Daftar Tugas Catatan Belum Ditandatangani",
    "backToDashboard": "Dasbor",
    "filtersHeading": "Filter",
    "filterAllNoteTypes": "Semua Jenis Catatan",
    "filterAllStatuses": "Semua Status",
    "filterAuthorPlaceholder": "Filter berdasarkan penulis…",
    "dateFromAria": "Tanggal mulai",
    "dateToAria": "Tanggal akhir",
    "columns": {
      "patient": "Pasien",
      "mrn": "MRN",
      "noteType": "Jenis Catatan",
      "noteTitle": "Judul",
      "author": "Penulis",
      "created": "Dibuat",
      "status": "Status",
      "actions": "Tindakan"
    },
    "actions": {
      "signSelected": "Tandatangani Terpilih ({{count}})",
      "signing": "Menandatangani…",
      "open": "Buka",
      "refresh": "Segarkan"
    },
    "loading": "Memuat catatan…",
    "empty": "Tidak ada catatan belum ditandatangani",
    "loadError": "Gagal memuat catatan yang belum ditandatangani",
    "retry": "Coba lagi",
    "toast": {
      "noneSelected": "Belum ada catatan dipilih",
      "signed_one": "{{count}} catatan berhasil ditandatangani",
      "signed_other": "{{count}} catatan berhasil ditandatangani",
      "signFailed": "Gagal menandatangani sebagian catatan",
      "partiallySigned_one": "{{count}} catatan ditandatangani, {{failed}} gagal",
      "partiallySigned_other": "{{count}} catatan ditandatangani, {{failed}} gagal"
    }
  },
  "type": {
    "progress": "Catatan Perkembangan",
    "historyPhysical": "H&P",
    "admission": "Catatan Rawat Inap",
    "discharge": "Ringkasan Pulang",
    "consult": "Konsultasi",
    "procedure": "Catatan Prosedur",
    "operative": "Catatan Operasi",
    "nursing": "Catatan Keperawatan"
  },
  "template": {
    "list": {
      "title": "Templat Catatan",
      "backToDashboard": "Dasbor",
      "newButton": "Templat Baru",
      "columns": {
        "name": "Nama",
        "noteType": "Jenis Catatan",
        "specialty": "Spesialisasi",
        "sections": "Bagian",
        "status": "Status",
        "actions": "Tindakan"
      },
      "active": "Aktif",
      "inactive": "Nonaktif",
      "loading": "Memuat templat…",
      "empty": "Belum ada templat. Buat satu untuk memulai.",
      "previewTitle": "Pratinjau Templat: {{name}}",
      "emptySection": "(kosong)",
      "tooltips": {
        "preview": "Pratinjau",
        "edit": "Ubah",
        "activate": "Aktifkan",
        "deactivate": "Nonaktifkan"
      },
      "toast": {
        "statusUpdated": "Status templat diperbarui"
      }
    },
    "form": {
      "editTitle": "Ubah Templat",
      "createTitle": "Buat Templat",
      "fields": {
        "name": "Nama Templat",
        "noteType": "Jenis Catatan",
        "specialty": "Spesialisasi",
        "sections": "Bagian"
      },
      "required": "*",
      "namePlaceholder": "mis., Catatan Perkembangan Standar",
      "selectNoteType": "Pilih jenis…",
      "selectSpecialty": "Pilih spesialisasi…",
      "addSection": "Tambah Bagian",
      "sectionNamePlaceholder": "Nama bagian (mis., Keluhan Utama)",
      "sectionDefaultPlaceholder": "Konten bawaan untuk bagian ini…",
      "cancel": "Batal",
      "create": "Buat Templat",
      "update": "Perbarui Templat",
      "toast": {
        "created": "Templat dibuat",
        "updated": "Templat diperbarui",
        "saveFailed": "Gagal menyimpan templat",
        "nameAndTypeRequired": "Nama dan jenis catatan wajib diisi",
        "atLeastOneSection": "Minimal satu bagian diperlukan"
      }
    },
    "specialty": {
      "general": "Umum",
      "internalMedicine": "Penyakit Dalam",
      "surgery": "Bedah",
      "pediatrics": "Anak",
      "cardiology": "Kardiologi",
      "neurology": "Neurologi",
      "orthopedics": "Ortopedi",
      "emergencyMedicine": "Kedokteran Darurat"
    },
    "scope": {
      "personal": "Pribadi",
      "group": "Kelompok",
      "global": "Seluruh RS"
    },
    "state": {
      "draft": "Draf",
      "published": "Dipublikasikan"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "Tebal",
      "italic": "Miring",
      "list": "Daftar",
      "templates": "Templat / Frasa Pintar",
      "saved": "Tersimpan {{time}}",
      "notSaved": "Belum tersimpan",
      "charactersLabel": "karakter",
      "save": "Simpan {{noteType}}",
      "placeholder": "Mulai mengetik {{noteType}} Anda… Gunakan \".\" untuk memicu frasa pintar.",
      "smartPhrases": {
        "patientName": "Nama Pasien",
        "mrn": "Nomor Rekam Medis",
        "dateOfBirth": "Tanggal Lahir",
        "allergies": "Alergi",
        "vitals": "Tanda Vital",
        "medications": "Obat",
        "problemList": "Daftar Masalah"
      }
    }
  }
}
